<template>
    <div class="notifications-bar__container" v-bind:class="{'notifications-bar__container--active' : show}" >
        <div class="notifications-bar__mask" v-on:click="closeModal"></div>
        <div class="notifications-bar text-sm shadow-sm" v-bind:class="{ 'notifications-bar--active' : show}" id="notifications-bar">
            <div class="notifications-bar__header margin-bottom-lg position-relative">
                <h2 class="h4">Notifications</h2>
                <button class="notifications-bar__toggle position-absolute top-0 right-0 reset cursor-pointer" v-on:click="closeModal">
                    <span class="icon icon--xxs bg-cover" :style="`background-image:url(${parent_theme_path}/assets/images/icons/close.svg)`"></span>
                    <span class="sr-only">Close Modal</span>
                </button>
            </div>
            <div class="notifications-bar__notifications">
                <notification v-for="alert in alerts" v-bind:key="alert.alert_id" v-bind:notification="alert"></notification>

            </div>
            
        </div>
    </div>
    
</template>
<script>
import Notification from './Notification.vue';

import {actions, getters, setters} from './store';
export default {
  components: { Notification },
    props: [
        'parent_theme_path'
    ],
    mounted:() => {
        actions.init();
    },
    computed: {
        count:() => {
            return getters.count();
        },
        alerts:() => {
            return getters.alerts();
        },
        show:()=> {
            return getters.show();
        }
    },
    methods: {
        closeModal: function() {
            setters.show(false);
            
        }
    }
   
}
</script>

<style scoped>
    .notifications-bar__container {
        width: 100%;
        top: 0;
        left: -9999em;
        height: 100%;
        background: transparent;
        position: absolute;
        
        z-index: 999;
    }
    .notifications-bar__container--active {
        left: 0;
    }
    .notifications-bar__mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .notifications-bar {
        position: fixed;
        
        top: var(--mega-nav-height);
        left: -9999em;
        /* opacity: 0; */
        z-index: 999;
        background: var(--color-white);
        width: 100%;
        height: 100%;
        padding: 20px;
        transition: 250ms ease-in-out all;
        transform: translateX(100%);
    }
    .admin-bar .notifications-bar {
        top: calc( 32px + var(--mega-nav-height));
    }
    @media screen and ( max-width: 782px ) {
         .admin-bar .notifications-bar {
            top: calc( 46px + var(--mega-nav-height));
        }
	}
    
    @media screen and (min-width:64rem) {
       .notifications-bar {
           width: 400px;
           top:0;
       }
       .admin-bar .notifications-bar {
           top: 32px;
       }
    }
    .notifications-bar__notifications {
        overflow: auto;
        max-height: calc(100% - 30px);
    }
    .notifications-bar--active {
        opacity: 1;
        transform: translateX(0);
        left: auto;
        right: 0;
    }
</style>